import React, {Component, Fragment} from 'react';
import {connect, Field, FieldArray, ErrorMessage} from 'formik';
import {FormattedMessage, injectIntl} from 'react-intl';
import classNames from 'classnames';
import get from 'lodash/get';
import messages from '../../../../res/translations/messages';
import ExpressionType from './ExpressionType';
import MinusButton from './MinusButton';
import FilterButton from './FilterButton';
import Error from '../../Error';
import TooltipContainer from '../../TooltipContainer';
import TooltipIcon from '../../TooltipIcon';
import {stripHtml} from '../../../utils/text';

const getPageDescription = (page) => {
    let description = page.items[0] && (page.items[0].title || page.items[0].text);
    if (description) {
        description = stripHtml(description);
    }
    return description ? `${page.id} - ${description}` : page.id;
};

// TODO remove disable lint
/* eslint-disable react/jsx-no-bind */
class Script extends Component {
    constructor(props) {
        super(props);
        this.addJump = this.addJump.bind(this);
        this.removeJump = this.removeJump.bind(this);
    }

    componentDidMount() {
        this.props.formik.registerField(this.props.id, this);
    }

    componentWillUnmount() {
        this.props.formik.unregisterField(this.props.id);
    }

    componentDidUpdate(prevProps) {
        if (this.props.id !== prevProps.id) {
            this.props.formik.unregisterField(prevProps.id);
            this.props.formik.registerField(this.props.id, this);
        }
    }

    addJump() {
        const {formik, id} = this.props;
        let scripts = get(formik.values, id);
        if (!scripts) {
            scripts = [];
        }
        formik.setFieldValue(id, scripts.concat({expression: [], jumpTo: ''}));
    }

    removeJump(index) {
        const {formik, id} = this.props;
        const scripts = get(formik.values, id);
        const newScripts = scripts.slice();
        newScripts.splice(index, 1);
        formik.setFieldValue(id, newScripts);
    }

    render() {
        const {intl, formik, id, currPage, allowAdd, postScript, items} = this.props;
        const pages = formik.values.editor.pages;
        const nextPages = pages.slice(currPage + 1);
        const previousPages = postScript ? pages.slice(0, currPage + 1) : pages.slice(0, currPage);

        return (
            <Fragment>
                {get(formik.values, id) && get(formik.values, id).map((script, index) => (
                    <div className="script" key={index}>
                        <div className="row pr-2 align-items-center">
                            <div className="col-9">
                                <FieldArray name={`${id}.${index}.expression`}
                                    render={(arrayHelpers) => (
                                        <div key={index}>
                                            <Field name={`${id}.${index}.expression`} previousPages={previousPages} component={ExpressionType}
                                                push={arrayHelpers.push}
                                                remove={arrayHelpers.remove}
                                                items={items}
                                            />
                                        </div>
                                    )}
                                />

                            </div>
                            <div className="col-3">
                                <label className="col-form-label" htmlFor={`${id}.${index}.jumpTo`}>
                                    <FormattedMessage {...messages.jumps.label.jumpTo} />
                                    {' '}
                                    <TooltipIcon message={messages.jumps.tooltip.jumpTo} />
                                </label>
                                <div className="d-flex">
                                    <Field id={`${id}.${index}.jumpTo`} name={`${id}.${index}.jumpTo`}
                                        className={classNames('form-control custom-select',
                                            {error: get(formik.errors, `${id}.${index}.jumpTo`) && get(formik.touched, `${id}.${index}.jumpTo`)})}
                                        component="select">
                                        <option value="" >{intl.formatMessage(messages.filters.select)}</option>
                                        {nextPages.map((page) => <option key={page.id} value={page.id}>{getPageDescription(page)}</option>)}
                                    </Field>
                                    <TooltipContainer tooltip={messages.jumps.tooltip.remove}>
                                        <MinusButton className="ml-2" remove={this.removeJump} index={index} />
                                    </TooltipContainer>
                                </div>
                                <ErrorMessage name={`${id}.${index}.jumpTo`}>
                                    {(message) => <Error reason={message.key} reasonParams={message.params} />}
                                </ErrorMessage>
                            </div>

                        </div>
                    </div>
                ))}
                {allowAdd && <FilterButton onClick={this.addJump}><FormattedMessage {...messages.jumps.button.new} /></FilterButton>}
            </Fragment>
        );
    }
}

export default connect(injectIntl(Script));
